export default __webpack_public_path__ + "static/media/mission.be30fc6b.jpeg";